import IndividualServices from './IndividualServicesPage';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Actions
import { addService, removeService } from 'store/reducers/appointment/actions';
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEventTellUsMoreSelected } from 'store/reducers/gtm/actions';

// Selectors
import {
  getIndividualServices,
  getMostCommonServices,
  getAllServices
} from 'store/reducers/individualServices/selectors';
import { getServicesCount } from 'store/reducers/appointment/selectors';
import { getActivePromotion } from 'store/reducers/promotions/selectors';

const mapStateToProps = state => {
  return {
    individualServices: getIndividualServices(state),
    servicesCount: getServicesCount(state),
    mostCommonServices: getMostCommonServices(state),
    allServices: getAllServices(state),
    promotion: getActivePromotion(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addService,
      removeService,
      gtmUserEventTellUsMoreSelected,
      goTo
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(IndividualServices);



// WEBPACK FOOTER //
// ./src/components/pages/IndividualServicesPage/IndividualServicesPageContainer.js